import { FC } from "preact/compat";
import { useApp } from "~/core/store";
import { Pulse } from "~/components";
import { FeaturePulseProps } from "./interfaces";

const FeaturePulse: FC<FeaturePulseProps> = ({ feature, ...rest }) => {
    const { status } = useApp();
    const isUnseen = status.isUnseen(feature);

    if (!isUnseen.value) {
        return null;
    }

    return <Pulse {...rest} />;
};

export default FeaturePulse;
